var map = {
	"./allinone-logo.svg": "0d3F",
	"./digibooking-logo.svg": "NAvi",
	"./hotelmeister-logo.svg": "lL+a",
	"./hotelsoftware-logo.svg": "8nc3",
	"./rainmaker-logo.svg": "/YHP",
	"./swisshotelcompetence-logo.svg": "LGw7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Evb8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg ^\.\/.*\-logo\.svg$
// module id = Evb8
// module chunks = 0